import { buildUpdateAddressInputSchema } from '../address/update-input.js';
import { typeIdSchema } from './create-input.js';
export const updateVendorAddressInputSchema = buildUpdateAddressInputSchema(typeIdSchema);
//# sourceMappingURL=update-input.js.map